import React from "react";
import { Row, Col, Badge } from "react-bootstrap";

const InfoCard = ({ title, sender, data, type }) => (
  <div className="card rounded p-0 border border-light shadow-sm h-100">
    <div className="card-body p-4">
      <div className="mb-4">
        <span className="text-muted fs-12 me-2">{type}:</span>
        <span className="fw-bold fs-14" style={{ color: "#0A2540" }}>
          {sender}
        </span>
      </div>
      <Row className="g-4">
        {data.map((item, idx) => (
          <Col key={idx} md={6}>
            <div className="text-muted fs-12 mb-1">{item.label}</div>
            <div className="fw-bold text-black fs-13">{item.value}</div>
          </Col>
        ))}
      </Row>
    </div>
  </div>
);

const Step4ConfirmTransaction = () => {
  const senderData = [
    { label: "Customer Type", value: "Individual" },
    { label: "ID Type", value: "Passport" },
    { label: "Nationality", value: "Philippines" },
    { label: "Phone Number", value: "+84 789908092" },
    {
      label: "Address",
      value: "123 Orchard Road, Singapore, Philippines, 12345",
    },
    { label: "ID Number", value: "check12month" },
    { label: "Date of Birth", value: "20/05/1990" },
    { label: "KYC Status", value: "Approved" },
    { label: "Customer Remarks", value: "kk" },
  ];

  const beneficiaryData = [
    { label: "Country", value: "Philippines" },
    { label: "Receiving Method", value: "Bank Transfer" },
    { label: "Account Number", value: "109450542671" },
    { label: "Bank Name", value: "OMNIPAY, INC." },
    { label: "Source of Funds", value: "Salary" },
    { label: "Purpose of Transfer", value: "Supplier/Vendor/Agent Payment" },
  ];

  const summaryData = [
    { label: "Receiving Amount", value: "36.45 PHP" },
    { label: "Exchange Rate", value: "1 SGD = 36.45 PHP" },
    { label: "Send Amount", value: "1 SGD" },
    { label: "Service Charge", value: "5 SGD" },
  ];

  return (
    <div className="mt-4">
      <Row className="g-4">
        <Col lg={4}>
          <InfoCard type="Sender" sender="Thuy Nga Phan" data={senderData} />
        </Col>
        <Col lg={4}>
          <InfoCard
            type="Beneficiary"
            sender="Thuynga Check level limit"
            data={beneficiaryData}
          />
        </Col>
        <Col lg={4}>
          <div className="card border-light rounded p-0 h-100">
            <div className="card-body p-4 d-flex flex-column h-100 justify-content-between">
              <div>
                {summaryData.map((item, idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between mb-3"
                  >
                    <span className="text-muted fs-13">{item.label}</span>
                    <span className="fw-bold text-black fs-13">
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>
              <div className="border-top pt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fw-bold fs-14" style={{ color: "#0A2540" }}>
                    Paid Amount
                  </span>
                  <span className="fw-bold fs-16" style={{ color: "#0A2540" }}>
                    6 SGD
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Step4ConfirmTransaction;
